import React, { useCallback, useState } from 'react';

// Components
import WpTimeInput from '../WpTimeInput';
import { WpForm, WpFormLayout } from '../../form';
import { WpButton } from '../../button';

const TimeInputDocs = () => {
  const WithoutForm = () => {
    const [time, setSelectedTime] = useState('2:30 pm');
    const handleChange = value => {
      console.log('--value: ', value);
      setSelectedTime(value);
    };
    return (
      <WpTimeInput
        id="without_form_input"
        label="Choose a time"
        helpText="help text here"
        value={time}
        onChange={handleChange}
      />
    );
  };

  const FormExample = () => {
    const handleSubmit = useCallback(data => {
      console.log('submitted data: ', data);
      alert('submitted, see console.log for returned data');
    }, []);

    return (
      <>
        <h3>Form Example</h3>
        <WpForm onSubmit={handleSubmit}>
          <WpFormLayout>
            <WpTimeInput id="time_form_input" label="Choose a time" helpText="help text here" required />
          </WpFormLayout>
          <WpButton btnType="submit">submit</WpButton>
        </WpForm>
      </>
    );
  };

  return (
    <div>
      <WithoutForm />
      <hr />
      <FormExample />
    </div>
  );
};

export default TimeInputDocs;
